const overrides: { [key: string]: string } = {
  people: 'person',
};

export default function singularize(word: string) {
  if (overrides[word]) {
    return overrides[word];
  }

  if (word.endsWith('ies')) {
    return `${word.slice(0, -3)}y`;
  }

  if (word.endsWith('s')) {
    return word.slice(0, -1);
  }

  return word;
}
